import { NetbankingAPI } from "aaa";
import { action, computed, observable } from "mobx";
import { NetbankingAPIClient } from "network/APIClient";
import { ICardLimit, ICardLimits } from "types/card";

// "F" is €3000,-
const DEFAULT_LIMIT = "F";

export class LimitsStore {
    @observable cardLimits?: ICardLimits;
    @observable selectedLimitShortCode = DEFAULT_LIMIT;
    @computed get selectedLimit(): ICardLimit | undefined {
        if (!this.cardLimits || this.cardLimits.limits.length === 0 || !this.selectedLimitShortCode) {
            return undefined;
        }

        return this.cardLimits.limits.find(limit => limit.shortCode === this.selectedLimitShortCode);
    }

    @observable isLoading: boolean = false;

    @action async load() {
        this.isLoading = true;

        try {
            const target = NetbankingAPI.getCreditCardLimits();
            this.cardLimits = await NetbankingAPIClient.requestType(target);
            this.isLoading = false;
        } catch (err) {
            this.isLoading = false;
            throw err;
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/LimitsStore.ts